export const ScheduleSendModal: string = 'ScheduleSendModal';
